import React, { useEffect, useRef, useState } from "react";
import { NavLink } from "react-router-dom";
import { GrUserManager } from "react-icons/gr";
import {
  Container,
  Row,
  Col,
  InputGroup,
  Navbar,
  Modal,
  Dropdown,
} from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Offcanvas from "react-bootstrap/Offcanvas";
import { CiSearch } from "react-icons/ci";
import { HiOutlineMenuAlt3 } from "react-icons/hi";
import { useSelector } from "react-redux";
import HeaderNav from "./HeaderNav";
import Logo from "../images/Logo Png-01.png";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const Header = () => {
  const [show, setShow] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [fullscreen, setFullscreen] = useState(true);
  const [brands, setBrands] = useState([]);

  const isLoggedIn = useSelector((state) => state.auth.user);
  const userDetails = useSelector((state) => state.auth.user);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [expanded, setExpanded] = useState(false);
  // const navbarRef = useRef(null);


  const modalHandleClose = () => setModalShow(false);
  const modalHandleShow = () => setModalShow(true);

  const baseUrl = process.env.REACT_APP_BASE_URL;
  const navigate = useNavigate();

  useEffect(() => {
    const fetchBrands = async () => {
      try {
        let baseUrl = process.env.REACT_APP_BASE_URL;
        const response = await axios.get(`${baseUrl}/api/brands`);
        setBrands(response.data);
      } catch (error) {
        console.error("Error fetching brands:", error);
      }
    };
    fetchBrands();
  }, []);

  const handleSearchSubmit = async (event) => {
    event.preventDefault();
    const searchValue = event.target.elements.search.value;

    if (searchValue) {
      navigate(`/search-results?search=${searchValue}`);
    }
    try {
      const response = await axios.get(`${baseUrl}/api/search-products`, {
        params: { search: searchValue },
      });

      if (response.data && response.status === 200) {
        console.log(response.data);
      }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        console.log(error.response.data.message);
      } else {
        console.error("Error fetching products:", error);
      }
    }
  };

  return (
    <>
      <div>
        <div className="main__header">
          <Container>

            <Navbar expand="lg" className="bg-body-tertiary nav_bg" expanded={expanded} >
              <Navbar.Brand href="/" className="logo_name">
                <img src={Logo} alt="Logo" />
              </Navbar.Brand>
              <Button variant="" className="Off__canvas__btn Offcanvas-btn" onClick={handleShow} > <HiOutlineMenuAlt3 /></Button>

              <div className="main__header__links" tabIndex={0} onBlur={() => setExpanded(false)}>
                <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={() => setExpanded(!expanded)} />
                <Navbar.Collapse id="basic-navbar-nav" className="nav_links nav_bar_a" >
                  <NavLink to="/" className="nav_link" onClick={() => setExpanded(false)}>Home</NavLink>
                  <NavLink to="/about" className="nav_link" onClick={() => setExpanded(false)}>About</NavLink>
                  <NavLink to="/shop" className="nav_link" onClick={() => setExpanded(false)}>Shop</NavLink>
                  <div className="brand_dropdown">
                    <Dropdown>
                      <Dropdown.Toggle id="dropdown-basic"> Brands </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item as={NavLink} to="/WizardScreen" onClick={() => setExpanded(false)}>Wizard Screen</Dropdown.Item>
                        {brands.map((brand) => (
                          <Dropdown.Item as={NavLink} to={`/brands/${brand.brand_id}`} key={brand.brand_id} onClick={() => setExpanded(false)} >
                            {brand.name}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                  <NavLink to="contact" className="nav_link" onClick={() => setExpanded(false)}>Contact us</NavLink>
                  <div className="client-img">
                  {isLoggedIn && userDetails?.profile_picture ? (
                    <img
                      src={`https://backend.bolt-corp.protofy.amgdigitalagency.com/storage/app/public/${userDetails.profile_picture}`}
                      alt="User Profile"
                    />
                  ) : null}
                </div>
                {isLoggedIn ? (
                  <NavLink to="dashboard/overview" className="client-name">
                    <i className="header_input_icon">
                      <GrUserManager />
                    </i>
                  </NavLink>
                ) : (
                  <NavLink to="/login" className="client-hover1">
                    Client Login
                  </NavLink>
                )}
                <HeaderNav />
                </Navbar.Collapse>
              </div>

              <div className="header__user__cart_responsive">
                <div className="client-img">
                  {isLoggedIn && userDetails?.profile_picture ? (
                    <img
                      src={`https://backend.bolt-corp.protofy.amgdigitalagency.com/storage/app/public/${userDetails.profile_picture}`}
                      alt="User Profile"
                    />
                  ) : null}
                </div>
                {isLoggedIn ? (
                  <NavLink to="dashboard/overview">
                    <i className="header_input_icon">
                      <GrUserManager />
                    </i>
                  </NavLink>
                ) : (
                  <NavLink to="/login" className="client-hover1">
                    Client Login
                  </NavLink>
                )}
                <HeaderNav />
              </div>
              <div className="user__cart">
                
              </div>

            </Navbar>
            <div className="header_input input-group-new">
              <InputGroup className="">
                <button onClick={modalHandleShow}>
                  <CiSearch />
                </button>
              </InputGroup>
            </div>
            <Modal
              className="search-modal"
              show={modalShow}
              fullscreen={fullscreen}
              onHide={modalHandleClose}
            >
              <Modal.Header closeButton />
              <form onSubmit={handleSearchSubmit}>
                <input
                  className="search-input"
                  placeholder="Search Product"
                  name="search"
                />
                <button type="submit" className="search-btn">
                  Search
                </button>
              </form>
            </Modal>

          </Container>
        </div>
      </div>

      <Offcanvas show={show} onHide={handleClose}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title></Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default Header;
